import { useAccount } from '../../context/AccountContext';
import EducationDashboardHome from './EducationDashboardHome';
import FitnessDashboardHome from './FitnessDashboardHome';
import TransientDashboardHome from './TransientDashboardHome';

export default function DashOverview() {
  const { account } = useAccount();
  const org_type = account?.organization?.org_type;

  if (org_type === "education") {
    return <EducationDashboardHome />;
  }

  if (org_type === "fitness") {
    return <FitnessDashboardHome />;
  }

  // ToDo: Account
  // Split current Profile.js as
  // Profile.js -> Map User model -> Only to User Auth and Org list and Roles
  // Account.js -> Map Organization model -> All major setting goes here
  return <TransientDashboardHome />;
}
